import TextField from "@mui/material/TextField";
import { FormEvent } from "react";
import { Button, useDataProvider } from "react-admin";

import { useForm, useMutation } from "../../../hooks";
import {
  CustomDataProvider,
  Language,
  ModalProps,
  Region,
  US_REGION,
} from "../../../types";
import {
  ActionButtonsBar,
  Form,
  LanguageSelectInput,
  Modal,
  RegionSelectInput,
} from "..";

interface FormState {
  email: string;
  language: Language;
  region: Region;
}

function InviteUserToFieldwireModal(props: ModalProps) {
  const defaultFormState: FormState = {
    email: "",
    language: Language.EN,
    region: US_REGION,
  };

  const { form, handleChangeForm, handleClearForm } = useForm(defaultFormState);

  const dataProvider = useDataProvider<CustomDataProvider>();
  const { mutate } = useMutation(
    (form: FormState) =>
      dataProvider.inviteUserToFieldwire(
        form.email,
        form.language,
        form.region,
      ),
    ["inviteUserToFieldwire", form],
    "User has been successfully invited! ✅",
  );

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    handleClearForm();
    props.handleClose();
    mutate(form);
  };

  return (
    <Modal open={props.modalOpen} title="New Invitation">
      <Form onSubmit={handleSubmit}>
        <TextField
          label="Email"
          name="email"
          onChange={handleChangeForm}
          value={form.email}
          required
        />
        <LanguageSelectInput
          label="Language"
          name="language"
          onChange={handleChangeForm}
          value={form.language}
          required
        />
        <RegionSelectInput
          label="Region"
          name="region"
          onChange={handleChangeForm}
          value={form.region}
          required
        />
        <ActionButtonsBar>
          <Button
            label="Cancel"
            onClick={props.handleClose}
            variant="fieldwire-secondary"
          />
          <Button
            disabled={!form.email}
            label="Send Invitation"
            type="submit"
            variant="fieldwire-primary"
          />
        </ActionButtonsBar>
      </Form>
    </Modal>
  );
}

export default InviteUserToFieldwireModal;
